/*
 * File: ResourceCard.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 30, 2025 at 1:03 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Components
import { Card } from '../Card';
import { ShareWidget as BaseShareWidget } from '../ShareWidget';


/**
 * Styles
 */

export const Wrapper = styled(Card)`
	padding: 16px 24px 14px;

	${({ $isPlaceholder }) => $isPlaceholder && css`
		pointer-events: none;

		* {
			pointer-events: none;
		}
	`}
`;

export const ActionBar = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	margin: 14px 0px 0px;

	svg {
		font-size: 0.95rem;
	}
`;

export const ActionContainer = styled.div`
	position: relative;
`;

export const ActionWidget = styled.div`
	position: absolute;
	height: auto !important;
	z-index: 100;
	background-color: ${({ theme }) => theme.surfaceBackground};
	border-radius: 8px;
	overflow: hidden;
	box-shadow: ${({ theme }) => theme.surfaceShadow};
	left: 2px;
	bottom: 40px;
	${({ theme }) => theme.navigationBorder !== 'transparent' && css`
		border: 1px solid ${theme.navigationBorder};
	`}
	opacity: 0;
	visibility: hidden;
	transform: scale(1.05);
	transition: visibility 0s linear 0.3s, opacity 0.3s 0s, transform 0.3s;
	pointer-events: none;
	width: 300px;
	z-index: 999;

	&.show {
		opacity: 1;
		visibility: visible;
		transform: scale(1);
		transition: visibility 0s linear 0s, opacity 0.3s 0s, transform 0.3s;
		pointer-events: all;
	}
`;

export const ActionWidgetContainer = styled.ul`
	line-height: 22px;
	padding: 8px 0px;
	margin: 0px;
	min-width: 300px;
	list-style: none;
	height: auto !important;
	color: ${({ theme }) => theme.primaryText};
	max-height: 200px;
	overflow: scroll;
`;

export const ActionWidgetRow = styled.li`
	padding: 8px 16px;
	height: auto !important;
	font-size: 15px;
	display: flex;
	align-items: start;
	cursor: pointer;
	width: 100%;
	position: relative;

	&:hover {
		background-color: ${({ theme }) => theme.neutralButton};
	}
	span {
		flex-grow: 1;
	}
`;

export const NavigationIcon = styled(FontAwesomeIcon)`
	align-items: center;
	position: relative;
	color: ${({ theme }) => theme.surfaceBackground};
`;

export const IconContainer = styled.div`
	width: 25px;
	height: 25px;
	border-radius: 50%;
	margin-right: 8px;
	position: relative;
	display: flex !important;
	align-items: center;
	justify-content: center;

	svg {
		font-size: 1.0rem;
		color: ${({ theme }) => theme.primaryText};
	}
`;

export const WidgetContentContainer = styled.div``;

export const ShareWidget = styled(BaseShareWidget)`
	left: 2px;
	bottom: 40px;
`;

export const Logo = styled.img`
	height: auto;
	flex-shrink: 0;
	position: relative;
	max-width: 100px;
`;

export const CardInner = styled.div`
	margin-top: 10px;

	h5 {
		margin: 0px 0px 6px;
	}
`;
